module.exports = __webpack_public_path__ + "img/defaultPhoneImg.880dd80c.png";